import { Event } from '@gp/models';
import { ComparerFn, ComparerResult } from '../common';

/**
 * Compares events by isTopHighlight property
 */
export const isTopHighlightComparer: ComparerFn<Event> = function(a: Event, b: Event): ComparerResult {
	if(!!a.isTopHighlight === !!b.isTopHighlight) return 0;

	return !!a.isTopHighlight ? -1 : 1;
}